import { Component } from '@angular/core';
import { ProductSearchService } from '@spartacus/core';
import { FacetList, FacetService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'custom-search-result',
  standalone: false,
  templateUrl: './custom-search-result.component.html',
  styleUrls: ['./custom-search-result.component.scss'],
})
export class CustomSearchResultComponent {
  constructor(
    private productSearchService: ProductSearchService,
    private facetService: FacetService
  ) {}

  facetList$: Observable<FacetList> = this.facetService.facetList$;
  results$ = this.productSearchService.getResults();
}
